import { combineReducers } from 'redux';
import poiReducer from './Poi';
import connectionReducer from './Connection';

// reducers
const appReducer = combineReducers({
  //   routing: routerReducer,
  connection: connectionReducer,
  poi: poiReducer,
});

export default appReducer;
